import React from 'react'

import { Button, ButtonVariant } from '@octane/spark'

export type AuthenticationSubmitButtonProps = {
    readonly submitButtonText?: string
}

const defaultProps = {
    submitButtonText: '',
}

export default function AuthenticationSubmitButton({
    submitButtonText,
}: AuthenticationSubmitButtonProps) {
    return (
        <Button
            id="formikSubmitButton"
            type="submit"
            variant={ButtonVariant.PRIMARY}
            fullWidth
        >
            {submitButtonText}
        </Button>
    )
}

AuthenticationSubmitButton.defaultProps = defaultProps
